import React from "react";
import { type LucideProps, Camera, Menu } from "lucide-react";
import { IoLogoGithub } from "react-icons/io";

const icons = {
  camera: Camera,
  menu: Menu,
  github: IoLogoGithub,
};

export type IconName = keyof typeof icons;

interface IconProps extends LucideProps {
  name: IconName;
}

export const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  const Component = icons[name] as React.ComponentType<LucideProps>;
  if (!Component) {
    return null;
  }
  return <Component {...props} />;
};

export const Icons = icons;
